// @ts-nocheck
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { safeJsonParse } from '../../utils/Utils';

const initialState = {
  isAuthenticate: !!localStorage.getItem('access_token'),
  userData: safeJsonParse('user_data'),
  profileData: safeJsonParse('profile_data'),
  permissions: safeJsonParse('user_permissions') || {},
  themeMode: localStorage.getItem('THEME_MODE') || 'light', // Initialize with saved value or default to light
};

const userSlice = createSlice({
  initialState,
  name: 'user',
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticate = true;
      state.userData = action.payload.user;
      state.profileData = action.payload.profile;
    },
    setUserPermissions: (state, action) => {
      state.permissions = action.payload.permissions;
    },
    setThemeMode: (state, action) => {
      state.themeMode = action.payload.themeMode;
    },
  },
});
export const { loginSuccess, setUserPermissions, setThemeMode } =
  userSlice.actions;
export default userSlice.reducer;
